import { useState } from "react";
import { toast } from "sonner";
import { UserPlus, Copy } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { shareOrCopy } from "@/lib/share";

export default function MemberInvite({ league }) {
  const [link, setLink] = useState(null);
  if (!league.member_invites || league.observer || league.archived) return null;
  const get = async () => {
    if (link) return link;
    try { const { data } = await api.get(`/leagues/${league.id}/my-invite-link`); setLink(data.link); return data.link; } catch (e) { toast.error(errMsg(e)); return null; }
  };
  const share = async () => {
    const l = await get();
    if (l) shareOrCopy({ title: league.name, text: `Rejoins-moi dans la ligue « ${league.name} » sur Ma Petite Ligue !`, url: l });
  };
  const copy = async () => {
    const l = await get();
    if (!l) return;
    try { await navigator.clipboard.writeText(l); toast.success("Lien copié"); } catch { toast.error("Copie impossible sur cet appareil"); }
  };
  return (
    <section className="mpl-card p-5 lg:col-span-2" data-testid="member-invite">
      <p className="mpl-eyebrow flex items-center gap-1.5"><UserPlus size={13} /> Inviter des amis</p>
      <p className="mt-2 text-sm text-slate-300">Ton lien perso pour faire entrer tes collègues ou amis dans la ligue.</p>
      <p className="mt-1 text-xs font-semibold text-[#B7F52A]" data-testid="member-invite-reward">+{league.referral_points || 100} pts au classement pour chaque nouveau compte créé avec ton lien.</p>
      {link && <p className="mt-2 break-all rounded-lg bg-black/30 p-2 font-mono text-[11px] text-slate-400" data-testid="member-invite-link">{link}</p>}
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" onClick={share} className="mpl-btn-primary" data-testid="member-invite-share"><UserPlus size={15} /> Inviter</button>
        <button type="button" onClick={copy} className="mpl-btn-ghost" data-testid="member-invite-copy"><Copy size={14} /> Copier le lien</button>
      </div>
    </section>
  );
}
